import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo'
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


export default function AbsentSummaryReport(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [detailFormVisible, setDetailFormVisible] = useState(false);


  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });
  const [detailItems, setDetailItems] = useState([]);
  const [student, setStudent] = useState({});
  const list = useRef(null);



  useEffect(() => {
    setLoading(true);


    var params = { login: util.getTrustedUser(), fromDate: 0, toDate: 0 };
    var url = config.Server + `/school/absent-student/summary/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setFilterItems(response);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setLoading(false);
      });

  }, []);

  const setRowActions = function (row) {
    return (
      <Row className="justify-content-md-center" style={{}}>
        <Button icon="pi pi-search" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => showStudentDetail(row)} title="مشاهده جزئیات" />
      </Row>
    );
  }
  const showStudentDetail = function(row){
    setStudent(row.student);
    var params = { login: util.getTrustedUser(), id: row.student.id };
    var url = config.Server + `/school/student/absent/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setDetailItems(response);
          setDetailFormVisible(true);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter hideOk={true} onCancelClick={() => { setDetailFormVisible(false) }} saving={false} />
    )
  }
  const setAbsentState = function (row, ti) {
    if(row.unLeagalAbsents.includes(ti)){
      return (
        <div style={{backgroundColor:"#ff0000", width:"15px", height:"15px", borderRadius:"50%", border:"1px solid #b0b0b0", margin:"5px"}}>

        </div>
      );
    }
    else if(row.leagalAbsents.includes(ti)){
      return (
        <div style={{backgroundColor:"#bef7b3ff", width:"15px", height:"15px", borderRadius:"50%", border:"1px solid #b0b0b0", margin:"5px"}}>

        </div>
      );
    }
    else{
      return (
        <div style={{backgroundColor:"#fff", width:"15px", height:"15px", borderRadius:"50%", border:"1px solid #b0b0b0", margin:"5px"}}>

        </div>
      );
    }
  }
    const handleDownloadPDF = async () => {
      var padding = 5;
      const input = document.getElementById("divList");
      const canvas = await html2canvas(input, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pdfWidth - 2 * padding;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const pageHeight = pdfHeight - 2 * padding;

      let remainingHeight = imgHeight;
      let startY = 0;
      let pageNumber = 0;

      const canvasPage = document.createElement("canvas");
      const ctx = canvasPage.getContext("2d");

      while (remainingHeight > 0) {
        // ارتفاع بخشی از تصویر که در این صفحه چاپ می‌شود
        const sliceHeight = Math.min(pageHeight * (canvas.width / imgWidth), canvas.height - startY);
        canvasPage.width = canvas.width;
        canvasPage.height = sliceHeight;

        // بریدن بخشی از تصویر اصلی
        ctx.clearRect(0, 0, canvasPage.width, canvasPage.height);
        ctx.drawImage(
          canvas,
          0,
          startY,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight
        );

        const imgChunk = canvasPage.toDataURL("image/png");

        if (pageNumber > 0) pdf.addPage();

        pdf.addImage(imgChunk, "PNG", padding, padding, imgWidth, (sliceHeight * imgWidth) / canvas.width);

        remainingHeight -= pageHeight;
        startY += sliceHeight;
        pageNumber++;
      }


      var pdfFileName = "لیست غایبین.pdf";
      pdf.save(pdfFileName);
  };
  return (
    <>
      <div className="card" id="divList" style={{padding:"1px"}} ref={list}>
        {
          loading ?
            <DataTable value={LoadingRows} className="p-datatable-striped">
              <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
              <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
            </DataTable>
            :
            <>
              <div className="page-caption">لیست خلاصه شده غایبین</div>

              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows 
                dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="student.nationalId" header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                <Column field="student.firstname" header={"نام"} sortable className="list-cell-text-align"></Column>
                <Column field="student.lastname" header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                <Column field="schoolClass.name" header={"کلاس"} sortable className="list-cell-text-align"></Column>
                <Column field="days" header={"تعداد کل روزهای غایب"} style={{ width: "130px" }} sortable className="list-cell-text-align"></Column>
                <Column field="unleagalDays" header={"تعداد کل روزهای غیبت غیر موجه"} style={{ width: "130px" }} sortable className="list-cell-text-align"></Column>
                <Column field="timeIndexes" header={"تعداد کل زنگهای غایب"} style={{ width: "130px" }} sortable className="list-cell-text-align"></Column>
                <Column field="unleagalTimeIndexes" header={"تعداد زنگ های غیبت غیر موجه"} style={{ width: "140px" }} sortable className="list-cell-text-align"></Column>
                <Column body={(row) => setRowActions(row)} exportable={false} style={{ width: "50px" }}></Column>
              </DataTable>

                <div className="" style={{ width:"calc(100% - 0px)"}}>
                <div style={{padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
                    <Row>
                        <Col md={3} style={{paddingTop:"30px"}}>
                            <Button icon="pi pi-pdf" label='خروجی pdf' rounded severity="success" style={{width:"180px", margin: "0px 3px", float:"right" }} onClick={() => {handleDownloadPDF()}} />
                        </Col>
                    </Row>
                </div>
                </div>

            </>
        }
      </div>
      {
        detailFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="لیست کامل غیبت های دانش آموز" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setDetailFormVisible(false)}>
            <>
              <div className="page-caption">{student.firstname + " " + student.lastname}</div>

              <DataTable value={detailItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows 
                dataKey="id" >
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="issueDate" body={(row)=>util.SeperateDate(row.issueDate)} header={"تاریخ"} sortable className="list-cell-text-align"></Column>
                <Column field="dayName" header={"روز"} sortable className="list-cell-text-align"></Column>
                <Column body={(row)=>setAbsentState(row, 0)} header={"ز اول"} className="list-cell-text-align"></Column>
                <Column body={(row)=>setAbsentState(row, 1)} header={"ز دوم"} className="list-cell-text-align"></Column>
                <Column body={(row)=>setAbsentState(row, 2)} header={"ز سوم"} className="list-cell-text-align"></Column>
                <Column body={(row)=>setAbsentState(row, 3)} header={"ز چهارم"} className="list-cell-text-align"></Column>
                <Column body={(row)=>setAbsentState(row, 4)} header={"ز پنجم"} className="list-cell-text-align"></Column>
                <Column body={(row)=>setAbsentState(row, 5)} header={" ز ششم"} className="list-cell-text-align"></Column>
              </DataTable>
            </>

          </Dialog>
          :
          <></>
      }

      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>
  );
}
